import * as yup from 'yup'

import { partnerDocumentsSchema } from 'features/Partners/components/PartnerDocumentsFormCard/schema'
import { INewPartnerStep3 } from 'features/Partners/types'
import { contactUrbvanSchema } from 'features/Partners/components/ContactUrbvanFormCard/schema'

export const partnerStep3Schema = (): yup.SchemaOf<INewPartnerStep3> => {
  return yup.object().shape({
    documents: partnerDocumentsSchema(),
    kam: contactUrbvanSchema()
  })
}
